(() => {
  'use strict';

  const ACTIVE_CLASS = 'soli-webi-bundle-active';
  const BUNDLE_ROOT_SELECTORS = [
    '.leadform-bundles',
    '[data-element-id="bundles"]',
    '[class*="leadform"] [class*="bundle"]',
  ];
  const BUNDLE_ITEM_SELECTORS = [
    '.lfcod-bundle-item',
    '[data-quantity]',
    'input[type="radio"][name*="bundle"]',
  ];
  const VARIANT_CONTROL_SELECTORS = [
    '.lfcod-variant-item',
    'select[name*="variant"]',
    'select[name*="option"]',
    '[data-variant-id]',
  ];

  const selectorMatch = (root, selectors) => selectors.some((selector) => root.querySelector(selector));

  const bundleHasOwnVariants = () => BUNDLE_ROOT_SELECTORS.some((rootSelector) => {
    const roots = document.querySelectorAll(rootSelector);

    return Array.from(roots).some((root) =>
      selectorMatch(root, BUNDLE_ITEM_SELECTORS) && selectorMatch(root, VARIANT_CONTROL_SELECTORS)
    );
  });

  const sync = () => {
    document.documentElement.classList.toggle(ACTIVE_CLASS, bundleHasOwnVariants());
  };

  let frame;
  const scheduleSync = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(sync);
  };

  const start = () => {
    sync();
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleSync);
})();
